var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dialog',{attrs:{"value":_vm.dialog,"width":420,"title":_vm.dialogTitle},on:{"input":_vm.onInput,"close":_vm.hide}},[(_vm.dialog)?_c('plan-required-content',{key:_vm.contentKey,attrs:{"feature":_vm.feature,"limit-key":_vm.limitKey,"max":_vm.max,"notice":_vm.notice},on:{"title":function($event){_vm.dialogTitle = $event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }